const sectors = [
  {
    title: "Public health and managed product support",
    text: "Supplying organized product solutions for pest control, fumigation, repellent needs, and LLINs distribution.",
  },
  {
    title: "Hygiene and specialized household items",
    text: "Providing practical hygiene support products for institutions, offices, and shared environments.",
  },
  {
    title: "Stationaries and office support",
    text: "Helping teams stay equipped with dependable office supplies and workplace essentials.",
  },
  {
    title: "General trading and wider sourcing",
    text: "Supporting diverse operational requirements through flexible procurement and distribution support.",
  },
];

const chooseUs = [
  "Focused service structure that makes sourcing clearer",
  "Professional product support for institutions and businesses",
  "Dependable coordination from inquiry to delivery",
  "Consistent presentation across multiple supply categories",
];

export default function AboutUsContent() {
  return (
    <>
      <section className="vex-page-hero" data-aos="fade-up">
        <div className="container">
          <div className="vex-page-hero-shell" data-aos="fade-up">
            <p className="vex-eyebrow">About VEX</p>
            <h1>
              A corporate supply and distribution company focused on dependable
              execution.
            </h1>
            <p>
              We are building a more refined business presence around reliable
              sourcing, organized service categories, and professional support
              for clients with real operational demands.
            </p>
          </div>
        </div>
      </section>

      <section className="vex-section vex-section-light" data-aos="fade-up">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-7" data-aos="fade-right">
              <div className="vex-content-panel vex-content-panel-tall">
                <p className="vex-panel-tag">Who We Are</p>
                <h3>
                  Structured to serve clients who need confidence in supply,
                  presentation, and delivery.
                </h3>
                <p>
                  VEX is a dynamic supply and distribution company serving
                  businesses, institutions, and managed environments through
                  clear service categories and a practical commitment to
                  reliability.
                </p>
                <p>
                  Our work is organized to keep sourcing efficient,
                  communication clear, and category support aligned with the way
                  clients actually buy and operate.
                </p>
              </div>
            </div>

            <div className="col-lg-5" data-aos="fade-left">
              <div className="vex-content-panel vex-content-panel-dark">
                <p className="vex-panel-tag vex-panel-tag-light">
                  Our Approach
                </p>
                <h3>
                  Classic corporate presentation backed by practical service
                  delivery.
                </h3>
                <p>
                  We focus on dependable supply relationships, responsive
                  follow-up, and a professional client experience that makes VEX
                  easier to work with across every touchpoint.
                </p>
              </div>
            </div>
          </div>

          <div className="vex-sector-grid vex-sector-grid-compact">
            {sectors.map((sector, index) => (
              <div
                key={sector.title}
                className="vex-sector-card"
                data-aos="fade-up"
                data-aos-delay={index * 70}
              >
                <h4>{sector.title}</h4>
                <p>{sector.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="vex-section" data-aos="fade-up">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="vex-content-panel">
                <p className="vex-panel-tag">Mission</p>
                <h3>
                  Deliver dependable supply and distribution support with
                  clarity.
                </h3>
                <p>
                  Our mission is to help organizations access the products they
                  need through responsive sourcing, organized categories, and
                  reliable delivery support.
                </p>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="vex-content-panel">
                <p className="vex-panel-tag">Vision</p>
                <h3>
                  Be a trusted corporate partner for multi-category sourcing.
                </h3>
                <p>
                  We aim to grow into a dependable name recognized for
                  professional presentation, reliable execution, and long-term
                  client value.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vex-section vex-section-light" data-aos="fade-up">
        <div className="container">
          <div className="vex-section-heading" data-aos="fade-up">
            <p className="vex-panel-tag">Why Choose Us</p>
            <h2>
              Steady support for procurement needs that cannot afford disorder.
            </h2>
          </div>

          <div className="vex-choose-grid">
            {chooseUs.map((item, index) => (
              <div
                key={item}
                className="vex-choose-card"
                data-aos="fade-up"
                data-aos-delay={index * 70}
              >
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
